import React from 'react';
import PropTypes from 'prop-types';
import { MAP_DATA_SERVICE_DATA_SET } from 'types';

export const scopes = [
  {
    value: MAP_DATA_SERVICE_DATA_SET.GNAF,
    placeholderLabel: 'Address search',
    label: 'Address'
  },
  {
    value: MAP_DATA_SERVICE_DATA_SET.GNAFLPID,
    placeholderLabel: 'Plan/Lot',
    label: 'Lot number'
  },
  {
    value: 'gps',
    placeholderLabel: 'Lat/Long Search',
    label: 'Lat, Long'
  }
];

const SearchTypeSelection: React.FC<Props> = ({ onChange, type }) => {
  const constructScopeList = () => {
    return scopes.map((item, idx) => {
      return (
        <li
          key={`mls-selection-type--list-${idx}`}
          className={`mls-selection-type--list ${
            type === item.value ? 'active' : ''
          }`}
          onClick={() => onChange(item)}
        >
          {item.label}
        </li>
      );
    });
  };

  return <ul className="mls-selection-type">{constructScopeList()}</ul>;
};

const propTypes = {
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string
};

type Props = PropTypes.InferProps<typeof propTypes>;

SearchTypeSelection.defaultProps = {
  type: scopes[0].value
};

export default SearchTypeSelection;
